export const services = [
  {
    title: 'Full-Service Design',
    description: 'Comprehensive interior design from concept to completion for Nigerian homes and offices, including space planning, local material selection, and project management across Abuja and Lagos.',
    icon: 'ri-home-4-line',
    badge: null
  },
  {
    title: 'Design Consultation',
    description: 'Expert guidance tailored to Nigerian homes—helping you make informed decisions about space, style, and locally sourced materials.',
    icon: 'ri-lightbulb-line',
    badge: {
      text: 'Popular',
      icon: 'ri-star-fill'
    }
  },
  {
    title: 'Space Planning',
    description: 'Optimize your Nigerian home or office layout for functionality and flow with our strategic space planning services.',
    icon: 'ri-layout-grid-line',
    badge: null
  },
  {
    title: 'Color Consultation',
    description: 'Transform your space with warm, Afrocentric color palettes that blend Nigerian heritage with contemporary luxury.',
    icon: 'ri-palette-line',
    badge: {
      text: 'New',
      icon: 'ri-sparkle-fill'
    }
  },
  {
    title: 'Furniture Selection',
    description: 'Curated furniture pieces sourced locally and internationally—blending Nigerian craftsmanship with global style, comfort, and functionality.',
    icon: 'ri-sofa-line',
    badge: null
  },
  {
    title: 'Project Management',
    description: 'Seamless coordination of local contractors, vendors, and timelines for stress-free execution of your Abuja or Lagos project.',
    icon: 'ri-file-list-3-line',
    badge: null
  }
];